import { createClient } from "@sanity/client";
import config from "src/config";
import { isWebDriver } from "src/utils/navigator";

export const client = isWebDriver()
  ? { fetch: () => null }
  : createClient({
      projectId: config.sanityProjectId,
      dataset: config.sanityDataset,
      useCdn: true,
      apiVersion: "2023-03-01",
    });
